export default window._cmsContent['whd/ineligible']